import React, { Fragment } from 'react'
import { Link } from 'react-router'
import {
  POTENTIAL_CUSTOMERS_STATUS,
  POTENTIAL_CUSTOMERS_STATUS_COLOR,
  POTENTIAL_CUSTOMERS_JUMP,
  POTENTIAL_CUSTOMERS_STATUS_PUSHED,
  POTENTIAL_CUSTOMERS_STATUS_FINISHED,
  CUSTOMER_MANAGE_EDIT_PATH
} from '@constant'

export default store => [
  {
    title: '用户名',
    render: ({ user, status, merchant_customer_id }) =>
      POTENTIAL_CUSTOMERS_STATUS_FINISHED == status ? (
        <Link to={`${CUSTOMER_MANAGE_EDIT_PATH}/${merchant_customer_id}`}>
          {user.nick}
        </Link>
      ) : (
        user.nick
      )
  },
  {
    title: '关键行为',
    width: 134,
    render: ({ action, entity, entity_type, entity_id }) => (
      <Fragment>
        <span style={{ color: '#333' }}>{action}</span>
        {['Example', 'Package'].includes(entity_type) && (
          <a
            style={{
              display: 'block',
              width: 94,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            onClick={() => {
              window.open(
                POTENTIAL_CUSTOMERS_JUMP[entity_type] + entity_id,
                entity.title,
                `height=667, width=375, top=${(window.screen.height - 667) /
                  2},left=${(window.screen.width - 375) / 2}`
              )
            }}
          >
            {entity.title}
          </a>
        )}
      </Fragment>
    )
  },
  {
    title: '创建时间',
    dataIndex: 'created_at'
  },
  {
    title: '状态',
    render: ({ status, push_count, last_push_time }) => (
      <Fragment>
        <span style={{ color: POTENTIAL_CUSTOMERS_STATUS_COLOR[+status] }}>
          {POTENTIAL_CUSTOMERS_STATUS[+status]}
        </span>
        {POTENTIAL_CUSTOMERS_STATUS_PUSHED == status &&
          [1, 2].includes(+push_count) &&
          store.calcDay(last_push_time, push_count) > 0 && (
            <p>{store.calcDay(last_push_time, push_count)}天后可再次发送</p>
          )}
      </Fragment>
    )
  },
  {
    title: '历史发送',
    render: ({ push_count }) => (push_count ? <span>{push_count}次</span> : '-')
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at'
  }
]
